import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Zaprzestano produkcji",
  "Spare part list": "Lista części zamiennych",
  "Download Excel": "Pobierz Excel",
  "Recent search list": "Lista ostatnich wyszukiwań",
  "No data": "Brak danych",
  "spare part": "część zamienna",
  "none": "brak",
  "no value": "brak wartości",
  "No results found": "Nie znaleziono wyników",
  "Spare parts for": "Części zamienne do",
  "Could not load cumulated data": "Nie można załadować skumulowanych danych",
  "commissioning part": "część rozruchowa",
  "wear part": "część zużywająca się",
  "Search": "Wyszukiwanie",
  "Tk": "Tk",
  "Spare part number": "Numer części zamiennej",
  "drawing": "rysunek",
  "Products for": "Produkty dla",
  "Available": "Dostępne",
  "MM": "MM",
  "The entered order code is invalid": "Wprowadzony kod zamówienia jest nieprawidłowy",
  "Recommended": "Zalecane",
  "No data available for the entered search parameters": "Brak dostępnych danych dla wprowadzonych parametrów wyszukiwania",
  "Search spare parts": "Wyszukiwanie części zamiennych",
  "Order code / product root / serial number": "Kod zamówienia / numer główny produktu / numer seryjny",
  "Characteristic": "Charakterystyka",
  "Please enter an order code": "Wprowadź kod zamówienia",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "W odniesieniu do aspektów jakości i bezpieczeństwa Endress+Hauser zdecydowanie zaleca stosowanie wyłącznie oryginalnych części zamiennych Endress+Hauser. \nUrządzenie może być konserwowane i naprawiane wyłącznie przez wykwalifikowany personel. \nNależy przestrzegać dokumentacji urządzenia, obowiązujących norm i wymogów prawnych, a także wszelkich certyfikatów!",
  "Maintenance advice": "Porady dotyczące konserwacji",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Do jakich produktów można użyć mojej części zamiennej? Wypełnienie kodu zamówienia części zamiennej (np. 71002865 lub XPD0024) pokazuje odpowiednie urządzenia, w których ta część zamienna może być używana.",
  "tool": "narzędzie",
  "Production numbers": "Liczby produkcyjne",
  "New alternative": "Nowa alternatywa",
  "There are no items selected. Please use the checkboxes to make your selection": "Nie wybrano żadnych elementów. Użyj pól wyboru, aby dokonać wyboru",
  "Service segmentation": "Segmentacja usług",
  "Seg": "Seg",
  "Valid": "Ważny",
  "Pos": "Poz",
  "Value": "Wartość",
  "service segmentation 2": "Części wymagające podstawowej wiedzy. Pomyślny udział w szkoleniu podstawowym E+H jest warunkiem wstępnym.",
  "Phase out date": "Data wycofania",
  "service segmentation 1": "Części wymagające podstawowej wiedzy.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Jakie części zamienne są dostępne dla mojego produktu? Wpisanie kodu zamówienia (np. FTC260-AA2A1 lub PMC51-BA21JB1CGBTDJB) lub identyfikatora produktu (np. FTC260 lub 83F50) spowoduje wyświetlenie odpowiednich części zamiennych.",
  "Set filter": "Ustaw filtr",
  "Search date": "Data wyszukiwania",
  "Group": "Grupa",
  "Warning": "Ostrzeżenie",
  "Description": "Opis",
  "Cancel": "Anuluj",
  "service segmentation 4": "Części do naprawy w fabryce. Wiedza ekspercka jest obowiązkowa.",
  "service segmentation 3": "Części wymagające specjalistycznej wiedzy. Pomyślne uczestnictwo w zaawansowanym szkoleniu E+H jest warunkiem wstępnym.",
  "Drawing Position Number": "Numer pozycji rysunku",
  "Spare parts search": "Wyszukiwanie części zamiennych",
  "Confirm": "Potwierdzenie",
  "Ordercode too short": "Zbyt krótki kod zamówienia",
  "Product status": "Status produktu",
  "Open": "Otwarty",
  "Clear": "Wyczyść",
  "PDF file with assembly instructions": "Plik PDF z instrukcją montażu",
  "Search products": "Wyszukiwanie produktów",
  "Export": "Eksport",
  "Production date": "Data produkcji",
  "Order stop": "Zatrzymanie zamówienia",
  "Calibration until": "Kalibracja do",
  "PDF file with compatibility information": "Plik PDF z informacjami o zgodności",
  "Add selection to cart": "Dodaj wybór do koszyka",
  "Mounting advices": "Porady dotyczące montażu",
  "Recommended parts only": "Tylko zalecane części",
  "not applicable": "nie dotyczy",
  "accessories": "akcesoria",
  "Cumulative spare parts list": "Zbiorcza lista części zamiennych",
  "YYYY": "RRRR",
  "Title": "Tytuł",
  "Error": "Błąd",
  "Ordercode too long": "Zbyt długi kod zamówienia",
  "Functions": "Funkcje",
  "Rec": "Rec",
  "Type": "Typ",
  "Spare sensor until": "Zapasowy czujnik do",
  "Spare parts until": "Części zamienne do",
  "Filter": "Filtr",
  "Check all": "Sprawdź wszystko",
  "Order code": "Kod zamówienia",
  "Repair until": "Naprawa do momentu",
  "Tag": "Tag",
  "Ok": "Ok",
  "Category code": "Kod kategorii",
  "Phase out": "Stopniowe wycofywanie",
  'Compatibility advices': 'Dokumenty dodatkowe',
  'Co.': 'Dod. dok.',
} as LocalizedDictionary;
